import React from 'react';
import { Link } from 'react-router5';
import { H3 } from 'ds/components/typography';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import SuitcaseIcon from 'assets/svg/developer/suitcase.svg';
import { useLocale } from 'locale';
import { ISearchDeveloper } from 'store/sagas/apiService/types';
import { Route } from 'config/routes';
import * as Styled from './styled';
import { DeveloperIntegrationLevel } from 'utils/entities';


interface CardProps {
  item: ISearchDeveloper;
}

const Card: React.FC<CardProps> = ({ item }) => {
  const { name, projectsCount = 0, logoUrl, images, id, integrationLevel } = item;
  const { t } = useLocale();
  const constructImageURI = useImageUrlBuilder();

  const mainImage = (images || []).find(({ isMain }) => isMain);
  const imageUrl = mainImage ? mainImage.imageUrl : null;
  const hideImages = integrationLevel === DeveloperIntegrationLevel.Free;
  const displayProjectCounter = integrationLevel === DeveloperIntegrationLevel.Full && projectsCount > 0;
  const logoSrc = !hideImages && logoUrl ? constructImageURI(logoUrl, { width: 150, fit: 'contain' }) : null;
  const coverSrc = !hideImages && imageUrl ? constructImageURI(imageUrl, { width: 300 }) : null;

  return (
    <Styled.CardWrapper>
      <Link routeName={Route.DeveloperPage} routeParams={{ id }}>
        <Styled.CardInner>
          <Styled.Cover>
            {coverSrc ? (
              <Styled.CoverImage src={coverSrc} />
            ) : null}
          </Styled.Cover>
          <Styled.LogoWrapper hasLogo={Boolean(logoSrc)}>
            {logoSrc ? (
              <img src={logoSrc} alt={t('developersSearchCityPage.card.logoAlt', { name })} />
            ) : <SuitcaseIcon width={43} />}
          </Styled.LogoWrapper>
          <Styled.DeveloperInfo>
            <H3 weight="bold">{name}</H3>
            {displayProjectCounter && (
              <Styled.DeveloperDescription>
                {t('developersSearchCityPage.card.description', {
                  count: projectsCount,
                })}
              </Styled.DeveloperDescription>
            )}
          </Styled.DeveloperInfo>
        </Styled.CardInner>
      </Link>
    </Styled.CardWrapper>
  );
};

export default Card;
